module.exports = __webpack_public_path__ + "img/zwssjg.bd520814.png";